import { render } from "./form-afip-data.vue?vue&type=template&id=740e9379"
import script from "./form-afip-data.vue?vue&type=script&lang=js"
export * from "./form-afip-data.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__